import React, {useState,useCallback, useEffect} from 'react';
import RGL, { WidthProvider } from 'react-grid-layout';
import AddSvg from '../../../svg/admin/Add';
import '../../../../node_modules/react-grid-layout/css/styles.css';
import '../../../../node_modules/react-resizable/css/styles.css';
import _ from 'lodash';
const ReactGridLayout = WidthProvider(RGL);
const convertToLayout=(data)=>{return data?.map((item,index)=>({i:`${index}`,x:0,y:index,w:1,h:1,data:item}))||[]}

function Component(props){
    const [layout,setlayout] = useState(convertToLayout(props.data?.pages||[]));
    useEffect(()=>{
        //work around for issue of ReactGridLayout not updating width
        window.dispatchEvent(new Event('resize'));
    },[layout]);
    useEffect(()=>{
        setlayout(convertToLayout(props.data?.pages||[]))
    },[props.data])
    
    const onDragStop=useCallback((layout)=>(layout_, oldItem, newItem)=>{
        const clonelayout=[...layout_]//_.cloneDeep(layout);
        const index=_.findIndex(layout,{'i':oldItem.i})
        let dragY=clonelayout[index].y
        if(layout[index].y<dragY){
            for(let i in layout){
                if(layout[i].y<=dragY&&layout[i].y>layout[index].y)
                    clonelayout[i].y=layout[i].y-1
            }
        }else if(layout[index].y>dragY){
            for(let i in layout){
                if(layout[i].y>=dragY&&layout[i].y<layout[index].y)
                    clonelayout[i].y=layout[i].y+1
            }
        }else return
        clonelayout[index].y=dragY
        setlayout(clonelayout)
        if(props.updateOrder)props.updateOrder(layout,clonelayout)
    },[layout])

    const onAddCard=()=>{if(props.onAddCard)props.onAddCard()}
    const onDelete=(item,index)=>()=>{if(props.onDelete){props.onDelete(item,index)}};
    const onEditKey=(item,index)=>(e)=>{if(props.onEditKey)props.onEditKey(item,index,'name',e.target.value)};


	return(
		<div style={{width:'100%',boxSizing:'border-box'}}>
            <div className='flex flex-col w-full'>
                <div className='w-full flex flex-row w-full items-center gap-[8px] justify-between py-[2px] px-[16px] text-[14px] font-[700]'>
                    <div className='w-[20px]'></div>
                    <div className='w-[16px]'>#</div>
                    <div className='w-[37px]'>icon</div>
                    <div className='flex-1'>頁面</div>
                </div>
                <ReactGridLayout
                    className="layout"
                    layout={layout}
                    cols={1}
                    rowHeight={46}
                    maxRows={layout.length} 
                    preventCollision={true} 
                    allowOverlap={true} 
                    isDraggable={true}
                    isResizable={false}
                    onDragStop={onDragStop(layout)} 
                    draggableHandle=".drag-handle" 
                    style={{height:layout.length*58,margin:0,padding:0}}
                > 
                    {layout?.map((item,index)=>
                        <div key={item.i} className='flex flex-row w-full items-center gap-[8px] justify-between px-[4px] rounded-[7px]' style={{border:'2px solid #D9D9D9'}}>
                            <div className='drag-handle cursor-pointer w-[20px]'>
                                <DragIcon/>
                            </div>
                            <div className='w-[16px]'>{Number(index)+1}</div>
                            <div className='w-[37px] h-[37px] bg-[#eee] rounded-[7px]'>
                              {item?.data?.icon&&<img src={item?.data?.icon} alt='icon' className='w-full h-full object-cover'/>}
                            </div>
                            <input 
                                className='flex-[1]'
                                style={{minWidth:100,width:100}}
                                value={props.data?.pages[index]?.name||''}
                                onChange={onEditKey(item,index)}
                            />
                            <div className='flex flex-row items-center gap-[8px] mr-[24px]'>
                              練習開始時顯示: 
                              <div>
                                <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                  <button
                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${item.data?.initial ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                    onClick={()=>{
                                      if(props.onEditKey)props.onEditKey(item,index,'initial',!item.data?.initial)
                                    }}
                                  ></button>
                                </div>
                              </div>
                            </div>
                            <div onClick={()=>{if(props.onClickPage)props.onClickPage(item.data)}} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{border:'1px solid #1F4CC8'}}>
                              編輯
                            </div>
                            <div 
                                className='cursor-pointer'
                                onClick={onDelete(item,index)}
                            >
                                <RemoveIcon/>
                            </div>
                        </div>
                    )}
                </ReactGridLayout>
                <div className='flex flex-row mt-[16px] p-[10px]'>
                    <div className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{border:'1px solid #1F4CC8'}} onClick={onAddCard}>
                        <AddSvg/> 添加頁面
                    </div>
                </div>
            </div>

            

           
        </div>
	);
}

export default Component 





const DragIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={17}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#000"
          d="M2 12.311h12v-1.333H2v1.333Zm0-3.333h12V7.644H2v1.334ZM2 4.31v1.333h12V4.311H2Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .311h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )

  function RemoveIcon(props) {
    return (
      <svg
        width={21}
        height={21}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          cx={10.1461}
          cy={10.1461}
          r={9.89242}
          fill="#F9FAFB"
          stroke="#111827"
          strokeWidth={0.507303}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.689 13.51a.64.64 0 11-.906-.906l2.458-2.458-2.458-2.458a.64.64 0 11.906-.906l2.458 2.458 2.458-2.458a.64.64 0 01.905.906l-2.458 2.458 2.458 2.458a.64.64 0 01-.905.905l-2.458-2.458-2.458 2.458z"
          fill="#111827"
        />
      </svg>
    )
  }